module.exports = __webpack_public_path__ + "img/video1.23e0a4a7.jpg";